import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const Header = () => {
  const sliderRef = useRef(null);

  // Enhanced slide data with more content
  const headerSlides = [
    {
      title: "Revolutionizing Energy with Solar Power Solutions",
      paragraph: "Join India's green energy revolution with our premium solar panel installations. Our cutting-edge photovoltaic systems deliver 30% higher efficiency than conventional panels, with a 25-year performance guarantee. We handle everything from site assessment to government subsidy paperwork, making your transition to solar completely hassle-free.",
      cta: "Get Your Free Solar Assessment Today →",
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
    },
    {
      title: "Custom Solar Solutions for Every Need",
      paragraph: "Whether you're a homeowner looking to reduce bills or a business aiming for sustainability, our tailored solutions fit perfectly. Our commercial solar systems can power entire factories, while residential setups typically pay for themselves in just 3-5 years. All installations come with smart monitoring and premium warranties.",
      cta: "Explore Our Solar Packages →",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
    },
    {
      title: "Sustainable Energy That Saves You Money",
      paragraph: "Our customers save an average of ₹18,000 monthly on electricity bills while reducing their carbon footprint. With government subsidies covering up to 40% of installation costs and our flexible financing options, solar has never been more accessible. Join 5,000+ satisfied customers across North India.",
      cta: "Calculate Your Savings →",
      image: "https://images.unsplash.com/photo-1521618755572-156ae0cdd74d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000, // Increased duration for more reading time
    fade: false,
    arrows: false,
    cssEase: 'ease-in-out',
    pauseOnHover: false,
    pauseOnFocus: false,
    appendDots: dots => (
      <div style={{
        position: "absolute",
        bottom: "40px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1
      }}>
        <ul style={{ 
          margin: 0,
          padding: 0,
          display: "flex",
          alignItems: "center"
        }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: i => (
      <div style={{
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        backgroundColor: "rgba(255,255,255,0.5)",
        margin: "0 6px",
        cursor: "pointer",
        transition: "all 0.3s ease"
      }} />
    )
  };

  return (
    <header id="header" style={{ position: 'relative', overflow: 'hidden' }}>
      <Slider ref={sliderRef} {...settings}>
        {headerSlides.map((slide, index) => (
          <div key={index}>
            <div className="intro" style={{
              backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.5) 100%), url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '100vh',
              minHeight: '700px',
              display: 'flex',
              alignItems: 'center',
              padding: '0 20px'
            }}>
              <div className="container">
                <div className="row">
                  <div className="col-lg-10 col-xl-8 mx-auto intro-text" style={{
                    color: 'white',
                    textAlign: 'left',
                    padding: '40px',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    borderRadius: '8px',
                    backdropFilter: 'blur(2px)'
                  }}>
                    <h1 style={{
                      fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                      marginBottom: '25px',
                      fontWeight: '800',
                      lineHeight: '1.3',
                      letterSpacing: '0.5px'
                    }}>
                      {slide.title}
                    </h1>
                    <p style={{
                      fontSize: 'clamp(1.2rem, 2vw, 1.8rem)',
                      marginBottom: '35px',
                      lineHeight: '1.7',
                      fontWeight: '300'
                    }}>
                      {slide.paragraph}
                    </p>
                    <button style={{
                      padding: '15px 30px',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      backgroundColor: '#FFD700',
                      color: '#333',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}>
                      {slide.cta}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </header>
  );
};